(function (window, $) {
  var Cls = {};
  var $obj1 = null;
  var $obj2 = null;
  var $obj3 = null;
  var $obj4 = null;
  var $obj5 = null;
  var $obj6 = null;

  Cls.init = function (next_func) {
    Cls.next_func = next_func;
    $obj1 = $("#seg0 .obj1");
    $obj2 = $("#seg0 .obj2");
    $obj3 = $("#seg0 .obj3");
    $obj4 = $("#seg0 .obj4");
    $obj5 = $("#seg0 .obj5");
    $obj6 = $("#seg0 .obj6");

    // $obj1.delay(1000).animate({'left':'+=100%'},0,function(){$(this).animate({'left':'-=100%'},800,'easeOutQuint')});
    // function(target,move,delay,duration,easing,func)
    Anime.side($obj1, "-=" + _WINDOW_WIDTH + "px", 100, 800, "easeOutQuart");
    Anime.side($obj2, "+=" + _WINDOW_WIDTH + "px", 100, 800, "easeOutQuart");
    Anime.side($obj3, "-=" + _WINDOW_WIDTH + "px", 100, 800, "easeOutQuart");
    Anime.vertical($obj4, "+=100px", 800, 800, "easeOutQuart");
    $obj6.delay(1600).animate({ opacity: "1" }, 1000);
    // function zoomIn(target,duration,easing,delay,func){

    setTimeout(function () {
      Opening.scrollZoom();
      $obj6.addClass("clickable");
      $obj6.click(Cls.next_func);
    }, 3000);
    // $obj1.css({'left':'+=100px'});
  };
  Cls.scrollZoom = function () {
    $obj5.css({ top: "375px", left: "427px" });
    Anime.zoomInFade($obj5, 2000, "easeOutQuart", 0);
    setTimeout("Opening.scrollZoom()", 2500);
  };

  window.Opening = Cls;
})(window, $brand);
